exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.str[data-v-5cbe68ad] {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 2%;\n}\n.text-right[data-v-5cbe68ad] {\n  text-align: right !important;\n}\n", "", {"version":3,"sources":["/Users/admin/Documents/env/jenkins_workspace/prod2-uc-static-lzauth/src/views/page/main/privacy/privacy.scss"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,6BAA6B;CAC9B","file":"privacy.scss","sourcesContent":["\n.str[data-v-5cbe68ad] {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 2%;\n}\n.text-right[data-v-5cbe68ad] {\n  text-align: right !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cbe68ad","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/views/page/main/privacy/privacy.scss
// module id = 6xxA
// module chunks = 2 3